export default __webpack_public_path__ + "static/media/intro-image.7c6bfb51.png";